import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import i18n from "@/i18n";
import { buildHead } from "@/lib/seo";
import { CookiesPage } from "@/components/pages/CookiesPage";
import { en } from "@/i18n/en";

export const Route = createFileRoute("/en/cookies")({
  head: () =>
    buildHead({
      lang: "en",
      page: "home",
      title: en.cookies.page.title + " · 2AM Hospitality",
      description: en.cookies.page.intro,
    }),
  component: () => {
    useEffect(() => {
      if (i18n.language !== "en") i18n.changeLanguage("en");
    }, []);
    if (i18n.language !== "en") i18n.changeLanguage("en");
    return <CookiesPage />;
  },
});
